//取得今天日期
const getFullToday = () => {
  const d = new Date();
  const day_list = ['日', '一', '二', '三', '四', '五', '六'];
  const today = `${d.toLocaleDateString()}（${day_list[d.getDay()]}）`;
  return today;
};
//取得日期
const getFormatDate = (val = 0) => {
  const d = new Date();
  const target = new Date(d.getTime() + 3600 * 1000 * 24 * val);
  const format = `${target.getFullYear()}/${
    target.getMonth() < 9 ? '0' + (target.getMonth() + 1) : target.getMonth() + 1
  }/${target.getDate() < 10 ? '0' + target.getDate() : target.getDate()}`;
  return format;
};

//格式化日期時間
const formatDateTime = (type, val) => {
  let text = '';
  switch (type) {
    case 'YYYY/MM/DD HH:mm':
      text =
        val.slice(0, 4) +
        '/' +
        val.slice(4, 6) +
        '/' +
        val.slice(6, 8) +
        ' ' +
        val.slice(8, 10) +
        ':' +
        val.slice(10, 12);
      break;
    case 'YYYY-MM-DD HH:mm':
      text =
        val.slice(0, 4) +
        '-' +
        val.slice(4, 6) +
        '-' +
        val.slice(6, 8) +
        ' ' +
        val.slice(8, 10) +
        ':' +
        val.slice(10, 12);
      break;
    case 'YYYY/MM/DD':
      text = val.slice(0, 4) + '/' + val.slice(4, 6) + '/' + val.slice(6, 8);
      break;
    case 'HH:mm':
      text = val.slice(8, 10) + ':' + val.slice(10, 12);
      break;
    case 'YYYYMMDD':
      text = val.slice(0, 4) + val.slice(5, 7) + val.slice(8, 10);
      break;
    case 'YYYYMMDDHHmmss':
      text = val.slice(0, 4) + val.slice(5, 7) + val.slice(8, 10) + val.slice(11, 13) + val.slice(14) + '00';
      break;
  }
  return text;
};

export { getFullToday, getFormatDate, formatDateTime };
